// promiseInterval - setInterval for calls that return a promise: the next
// call is one interval after the last one is done, not after it started.
// - promiseCall is called at once, unless delayFirst is set (for callers
//   that make their own first call).
// - A call that fails is logged; polling goes on.
// - stop() also ends a wait that is under way.
// - With hiddenInterval, a hidden tab waits at least that long, and the
//   call comes at once when the tab shows again.

// how often data polls go while the tab is hidden
export const HIDDEN_INTERVAL = 60000

export const promiseInterval = (
  promiseCall,
  interval,
  { delayFirst = false, hiddenInterval = 0 } = {},
) => {
  let stopped = false
  let timer = null
  let wake = null
  let slowSleep = false

  const sleep = () =>
    new Promise((resolve) => {
      wake = resolve
      slowSleep = hiddenInterval > interval && document.hidden
      const wait = slowSleep ? hiddenInterval : interval
      timer = window.setTimeout(resolve, wait)
    })

  const wakeUp = () => {
    window.clearTimeout(timer)
    wake?.()
  }
  const onVisibilityChange = () => {
    if (slowSleep && !document.hidden) wakeUp()
  }
  if (hiddenInterval > 0) {
    document.addEventListener('visibilitychange', onVisibilityChange)
  }

  const loop = async () => {
    if (delayFirst) await sleep()
    while (!stopped) {
      try {
        await promiseCall()
      } catch (error) {
        console.error(error)
      }
      if (stopped) break
      await sleep()
    }
  }

  loop()

  return {
    stop: () => {
      stopped = true
      wakeUp()
      if (hiddenInterval > 0) {
        document.removeEventListener('visibilitychange', onVisibilityChange)
      }
    },
  }
}
